import { render, staticRenderFns } from "./RevenueShareSubHeader.vue?vue&type=template&id=24e51cb5&scoped=true&"
import script from "./RevenueShareSubHeader.vue?vue&type=script&lang=js&"
export * from "./RevenueShareSubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e51cb5",
  null
  
)

export default component.exports